












































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IActivity } from "@/models/interfaces/lessons";

@Component
export default class ActivityBox extends Vue {
  /**
   * Activity data
   */
  @Prop({ required: true, type: Object })
  private data!: IActivity;

  /**
   * Opens an activity in a separate tab with teacher's token
   */
  private openActivity() {
    const redirectURL = process.env.VUE_APP_LB_APP_URL;
    const token = localStorage.getItem("token");
    const redirectUrl = `${redirectURL}/activity/${this.data.activityId}?t=${token}&blockNavigation=true`;

    window.open(redirectUrl);
  }
}
